<template>
  <!-- Change Request Form -->
  <v-dialog
    content-class="documentDialog changeRequestDialog"
    class="changeRequestDialog"
    v-model="addPosShopObjectId"
    transition="scale-transition"
    @update:returnValue="onPopupClose"
    persistent
    scrollable
    @keydown.esc="closePopup()">
    <v-card xs12 v-if="addPosShopObjectId">
      <v-card-title class="documentDialog_title primary">
        <v-layout row wrap >
          <v-flex xs11>
            <p>Modification <span v-show="addPosShopName"> of {{ addPosShopName }} - </span><span v-show="localization.localization_text">{{ localization.localization_text }}</span></p>
          </v-flex>
          <v-flex xs1 style="text-align: right;">
            <v-btn dark icon
            @click.native="closePopup()" style="" >
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
        <v-card-text style="padding: 0px!important;">

      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Add new POS</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">Send us your modifications</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" v-if="localization">
            <v-layout row wrap>
              <v-flex md6>
                <h3>Data</h3>
                <br/>
                <h4>Localization description (terminal, gate,...)</h4>
                <v-text-field v-model="localization.localization_text" :counter="60" label="" />
              </v-flex>
              <v-flex md6>
                <h3>Comment (URL, explanation)</h3>
                <br/>
                <br/>
                <v-text-field v-model="localization.localization_text_comment" label="" />
              </v-flex>
            </v-layout>

            <!-- usefull url -->
            <h4>Useful URL</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-text-field v-model="localization.url" :counter="400" label="" />
              </v-flex>
              <v-flex md6>
                <v-text-field v-model="localization.url_comment" label="" />
              </v-flex>
            </v-layout>

            <!-- who -->
            <h4>Who</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-combobox
                  v-model="localization.who"
                  label=""
                  multiple
                  small-chips
                >
                  <template :v-slot:selection="localization.who">
                    <v-chip close>
                      <strong>{{ localization.who }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex md6>
                <v-text-field v-model="localization.who_comment" label="" />
              </v-flex>
            </v-layout>

            <!-- what -->
            <h4>What</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-combobox
                  v-model="localization.what"
                  label=""
                  multiple
                  small-chips
                >
                  <template :v-slot:selection="localization.what">
                    <v-chip close>
                      <strong>{{ localization.what }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex md6>
                <v-text-field v-model="localization.what_comment" label="" />
              </v-flex>
            </v-layout>

            <!-- how -->
            <h4>How</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-combobox
                  v-model="localization.how"
                  label=""
                  multiple
                  small-chips
                >
                  <template :v-slot:selection="localization.how">
                    <v-chip close>
                      <strong>{{ localization.how }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex md6>
                <v-text-field v-model="localization.how_comment" label="" />
              </v-flex>
            </v-layout>

            <!-- tags to sort -->
            <h4>Other</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-combobox
                  v-model="localization.other"
                  label=""
                  multiple
                  small-chips
                >
                  <template :v-slot:selection="localization.other">
                    <v-chip close>
                      <strong>{{ localization.other }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex md6>
                <v-text-field v-model="localization.other_comment" label="" />
              </v-flex>
            </v-layout>

            <h4>Description</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-textarea
                  outline
                  name="input-7-4"
                  label=""
                  :counter="1000"
                  v-model="localization.description" required >
                </v-textarea>
              </v-flex>
              <v-flex md6>
                <v-textarea outline :counter="1000" v-model="localization.description_comment" label="" />
              </v-flex>
            </v-layout>

            <v-textarea
              outline
              name="input-7-4"
              :counter="1000"
              v-model="localization.proof_comment"
              label="Comment "
              data-vv-name="proofMessage"
              :error-messages="errors.collect('proofMessage')"
              v-validate="'required'"
              required
            ></v-textarea>

          </v-stepper-content>
          <v-stepper-content step="2">
            <div
              class="mb-5"
              height="200px"
              style="text-align:center; padding-top:50px;">
              <h3>
                Thank you for your contribution!
              </h3>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      </v-card-text>
      <v-card-actions class="bottom_panel">
          <!-- stepper 1 -->
          <v-btn v-if="e1 == 1"
            color="primary" disable="checkDatas"
            @click="stepper_go_to_step_2()"
          >
            Send modification request
          </v-btn>
          <v-btn flat @click.native="closePopup()" v-if="e1 == 1">Cancel</v-btn>
          <span class="red--text" v-if="error_message" v-text="error_message" />

          <!-- stepper 2 -->
          <v-btn color="secondary" flat v-if="e1 == 2"
            @click.native="closePopup()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import transform from 'lodash/transform'
// import isEqual from 'lodash/isEqual'
// import isObject from 'lodash/isObject'
import { createNamespacedHelpers } from 'vuex'
import CREATE_CHANGE_REQUEST from '@/graphql/CreateChangeRequest.gql'

const { mapMutations, mapState } = createNamespacedHelpers('locationForm')

export default {
  name: 'AddPosForm',
  data () {
    return {
      active: -1,
      e1: 1,
      displayShowChangeRequest: true,
      localization_id: -1,
      localization: {
        'airport_name': '',
        'name': '',
        'localization_text': '',
        'note': '',
        'url': '',
        'who': [],
        'what': [],
        'how': [],
        'description': '',
        'name_comment': '',
        'localization_text_comment': '',
        'note_comment': '',
        'url_comment': '',
        'who_comment': '',
        'what_comment': '',
        'how_comment': '',
        'description_comment': '',
        'proof_comment': ''
      },
      new_shopDefaultData: {
        'airport_name': '',
        'name': '',
        'localization_text': '',
        'note': '',
        'url': '',
        'who': [],
        'what': [],
        'how': [],
        'description': '',
        'name_comment': '',
        'localization_text_comment': '',
        'note_comment': '',
        'url_comment': '',
        'who_comment': '',
        'what_comment': '',
        'how_comment': '',
        'description_comment': '',
        'proof_comment': ''
      },
      error_message: null,
      dictionary: {
        custom: {
          proofMessage: {
            required: () => 'Proof / Message can not be empty'
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  computed: {
    ...mapState(['viewedAddPosDialog', 'addPosShopObjectId', 'addPosShopName'])
  },
  methods: {
    ...mapMutations(['setViewedAddPosDialog',
      'setAddPosShopObjectId',
      'setAddPosShopName',
      'setViewedChangeRequestDialog',
      'setViewedChangeRequestPos',
      'setViewedChangeRequest']),
    createChangeRequest (changeRequest) {
      var normalTypeFields = ['name', 'localization_text', 'note', 'url', 'description']
      var m2oTypeFields = ['who', 'what', 'how', 'other']
      var operations = []
      // process normal field type
      for (const fieldName of normalTypeFields) {
        // update
        if (this.localization[fieldName] !== undefined && this.localization[fieldName] !== '') {
          operations.push({
            'field_name': fieldName,
            'field_type': 'string', // string, int, double
            'value_new': this.localization[fieldName],
            'operation_type': 'create', // validate, reject, update
            'comment': this.localization[fieldName + '_comment']
          })
        }
      }
      // process m2o fields type
      for (const fieldName of m2oTypeFields) {
        var valueNewM2o = []
        if (this.localization[fieldName] !== undefined && this.localization[fieldName].length > 0) {
          for (const tag of this.localization[fieldName]) {
            valueNewM2o.push(['add', tag])
          }
        }
        if (valueNewM2o.length > 0) {
          operations.push({
            'field_name': fieldName,
            'field_type': 'm2o', // string, int, double, m2o
            'value_new': valueNewM2o, // 0: validate, 1: reject, 2: add
            'operation_type': 'create',
            'comment': this.localization[fieldName + '_comment']
          })
        }
      }
      var changeRequestObject = {
        'type': 'create_pos',
        'object_id': parseInt(this.addPosShopObjectId),
        'operations': operations,
        'proof_comment': this.localization.proof_comment
      }

      this.$apollo.mutate({
        mutation: CREATE_CHANGE_REQUEST,
        variables: {
          change_request: changeRequestObject
        }
      }).then((data) => { this.e1 = 2 })
        .catch((error) => {
          if (error.networkError.statusCode === 401) {
            this.$auth0.login()
          } else {
            this.addError(error)
          }
        })
    },
    async stepper_go_to_step_2 () {
      this.error_message = null
      // let diff = this.difference(this.changeRequest, this.viewedChangeRequestOrig)
      let check = await this.$validator.validateAll()
      if (!check) { return }
      // Search after at least one updated field or opinion. Skip comment field.
      // difference fonction let empty value on array when there is no difference so we need to filter them.
      // let diffLocalization = diff.localizations.filter(function () { return true })[0]
      // let isSomeUpdatedField = diff.localizations !== undefined ? Object.keys(diffLocalization).some(key => key.indexOf('_comment') === -1 ? key : false) : false
      // // Check the user edit at least one other field than proof_comment.
      // if (!isSomeUpdatedField) {
      //   this.error_message = 'You must edit at least one field !'
      //   return
      // }
      this.createChangeRequest(this.localization)
    },
    // difference (object, base) {
    //   // return a diff between 2 objects.
    //   function changes (object, base) {
    //     return transform(object, function (result, value, key) {
    //       if (!isEqual(value, base[key])) {
    //         let res = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value
    //         if (isObject(res) && Object.keys(res).length === 0) {
    //           return
    //         }
    //         result[key] = res
    //       }
    //     })
    //   }
    //   return changes(object, base)
    // },
    onPopupClose (event) {
      if (event === undefined) {
        this.closePopup()
      }
    },
    async closePopup () {
      this.setViewedAddPosDialog(false)
      this.setAddPosShopObjectId(false)
      this.setAddPosShopName(false)

      this.e1 = 1
      this.localization = Object.assign({}, this.new_shopDefaultData)
    }
  }
}
</script>
<style scoped>
.changeRequestDialog .v-input {
    padding: 5px;
}
.changeRequestDialog .v-input--selection-controls {
    padding: 0px;
    margin: 0px;
}
.changeRequestDialog .v-input--selection-controls .v-input__slot {
  margin-bottom: 0px;
}
.changeRequestDialog {
  width:1500px !important;
}
.chip_tags .v-chip__content{
  height:25px;
  padding: 0 8px !important;
}
.chip_tags_btn {
  border: none!important;
  height: 18px!important;
  width: 18px!important;
  margin: 0px;
  bottom: 3px;
}
.chip_tags_btn_left {
  margin-left:5px;
}

.localization_tab {
  /* border: 1px solid rgb(180, 180, 180) */
  padding:5px;
  padding-top: 8  px;
  margin-bottom: 7px;
  -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
}

.vtabs_localization .v-tabs__bar{
  visibility: hidden;
  height: 0px;
}

.localization_select .v-input__control>.v-input__slot {
  border: 2px solid #1976d2 !important;
}

.vtabs_localization .textarea_description {
  margin-bottom: 0px;
}
.vtabs_localization .textarea_description .v-text-field__details {
  margin-bottom: 0px;
  height: 0px;
}

</style>
